import { Component, Input } from '@angular/core';

@Component({
  selector: 'placeme-job-advantages',
  templateUrl: './job-advantages.component.html',
  styleUrls: ['./job-advantages.component.scss'],
})
export class JobAdvantagesComponent {
  @Input() advantages: any[];

  constructor() {}
}
